/* eslint-disable @typescript-eslint/no-unused-vars */
import QuickModal from "../modal"   // s42
import { quickFiltersOf, useSetQuickFilters } from "../../contexts/HeaderExtrasContext"   // s42
import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react"
import {
  Button,
  Layout,
  message,
  notification,
  Select,
  Table,
  TablePaginationConfig,
  TableProps,
} from "antd"
// import { Download, Plus, Trash, Upload } from "react-feather";
import { useTranslation } from "react-i18next"
import "./TableExtended.less"
// PERF-07 (2026-09-03): eksport kutubxonalari SHU YERDA statik import qilinardi va
// TableExtended tizimdagi HAR BIR jadval sahifasida ishlatiladi. Natijada jsPDF,
// xlsx va 1 MB dan ortiq base64 shrift ma'lumoti (Arimo/Roboto) hech kim eksport
// qilmasa ham HAR SAHIFADA yuklanardi. Endi ular faqat tugma bosilganda yuklanadi.
import { ExcelExtensions, IExcelOptions } from "../excel/ExportOptionsModal"
// import UploadExcelModal from "../excel/UploadExcelModal";
import checkObj from "../../utils/checkObj"
import { exportTotal } from "../../utils/totalSign"
import Pagination from "../pagination/Pagination"
import {
  FilterValue,
  RowSelectionType,
  SorterResult,
  TableRowSelection,
} from "antd/lib/table/interface"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import { PLACEHOLDER_MUTATION } from "../../rest-api/mutations/types/placeholder"
import TableSummary from "./TableSummary"
import MobileCards from "./MobileCards"   // Boshliq (2026-09-05): telefonda jadval o'rniga kartalar
import useStickyTable, { asliLayout } from "./useStickyTable"   // tog'a #4153: sarlavha va «Итого» joyida, qatorlar aylanadi
import { IColumnType } from "../../types"
import monthDiff from "../MonthDIfference"
import Header from "../../containers/layout/Header"
import { useLocation } from "react-router-dom"
import qs from "qs"
import { GET_USER } from "../../rest-api/queries/userDetail"
import useQueryParams from "../../hooks/useQueryParams"

import moment from "moment"

import { useMutation, useQuery } from "@tanstack/react-query"
import {
  AuthActions,
  AuthContext,
  AuthForms,
} from "../../contexts/auth/AuthContext"
import { MODULE_COLUMNS_DEFINITION, hiddenColumnKeys } from "../../data/moduleColumns"
import { getUiPref, setUiPref, loadUiPrefs, onUiPrefs, uiPrefsLoaded, safePrefKey } from "../../utils/uiPrefs"   // tog'a #3493
import { isBatchColumn, isMainUser } from "../../utils/mainSystem"   // tog'a #4100/#4104
import { useTodayEmpty } from "./TodayEmpty"   // Tog'a #438

// Boshliq (2026-09-03): «Роли и права → ustunlar» o'zgarganda foydalanuvchi F5 bosmasa ham
// bo'limga kirganda qo'llansin — huquqlar (ustun cheklovi shu yerda) 30 s dan ko'p o'tgan
// bo'lsa qayta so'raladi. Bitta yengil so'rov, faqat bo'lim ochilganda (polling emas).
let lastPermsRefreshAt = 0

export interface ITableExtended extends Omit<TableProps<any>, "columns"> {
  name: string
  topContent?: React.ReactNode   // tog'a #3490: sarlavha ostida, jadval ustida (masalan kontragent qarzi kartasi)
  /** tog'a #3493: ustun tanlovi kaliti — bitta sahifadagi ikki jadval (masalan kunlar va kun ichidagi mijozlar) bir-birining tanlovini yozmasin */
  columnsKey?: string
  refetch: () => void
  tableProps?: Partial<ITableExtended>
  filterComponent?: FunctionComponent<any>
  refetchAllData?: () => any   // tog'a #309: Promise qaytaradi (react-query refetch) — eksport kutadi
  onAdd?: () => void
  onImport?<T>(arr: T[]): void
  onDelete?: (rows: React.Key[]) => void
  onRowSelect?: (selectedRowKeys: any[]) => void
  onSort?: ({
    field,
    order,
  }: {
    field: string
    order: "ASC" | "DESC" | ""
  }) => void
  columns: IColumnType[]
  deleteBulkMutation?: any
  totalOutcomeQuery?: any
  totalOutcomeQueryVariables?: any
  totalOutcome?: any
  sampleData?: object
  excelDetail?: object
  pageInfo?: any
  rightButtons?: JSX.Element[]
  leftButtons?: JSX.Element[]
  hasFilter?: boolean      // s42: Page o'z filterComponent'ini beradi (standart oyna kerak emas)
  filterMatcher?: string   // s41: Фильтр tugmasi qaysi query kalitini ochadi (namedFilter → `${name}filtering`)
  hideAdd?: boolean
  hideDelete?: boolean
  hideImport?: boolean
  hideExport?: boolean
  hideSummary?: boolean
  hideCalculator?: boolean
  isDefective?: boolean
  isHasTitle?: boolean
  titleName?: string
  /** tog'a #4147/#4152 (2026-10-12): sahifalash URL kaliti (`<pageName>pageNumber` / `<pageName>perPage`) — sahifaning usePagination(...)
   *  nomi bilan BIR XIL bo'lishi shart. Berilmasa: titleName, u ham bo'lmasa name. GroupedPage o'z kalitini (title) beradi. */
  pageName?: string
  withoutImportCheck?: boolean
  /** tog'a #2892: Excel sarlavhasi → kalit (ruscha/o'zbekcha nomlar), import oynasidagi ustun izohi va «Скачать шаблон» */
  importAliases?: Record<string, string[]>
  importColumnsHint?: string[]
  importTemplate?: () => void | Promise<void>
  rowSelectionType?: RowSelectionType
  selectableColumns?: boolean
  summaryKeys?: string[]
  summaryKeyRenders?: any
  summaryCellRenders?: Record<string, (raw: number) => React.ReactNode>   // tog'a 1156
  isGroup?: boolean
  rowSelectionConfig?: TableRowSelection<any>
  type?: number
  allData?: []
  loadingAllData?: boolean
  setIsSelectedRows?: React.Dispatch<React.SetStateAction<any[]>>
}

export enum TableActions {
  ADD,
  DELETE,
  EXPORT,
  IMPORT,
}

// tog'a #3493: «№» ustuni — BITTA doimiy obyekt va doimiy kalit «__no». Avval u har chizishda yangidan yaratilardi va tanlovda
// ba'zan «olib tashlangan» bo'lib yozilardi; endi uni ham foydalanuvchi o'zi yoqadi/o'chiradi.
const NO_COLUMN: IColumnType = {
  key: "__no",
  title: "№",
  render: (_row: any, _: any, index: number) => index + 1,
} as any

export default function TableExtended<T extends object>(props: ITableExtended) {
  // tog'a #4147/#4152 (2026-10-12): sahifalash kaliti sahifaning usePagination nomi bilan BIR XIL bo'lishi shart. Avval doim titleName
  // olinardi: GroupedPage («purchasesByFilter» → ma'lumot «purchasesByFilte» kalitida) va titleName'siz jadvallarda (hisobotlar →
  // «undefinedpageNumber») URL o'zgarardi-yu, so'rov o'zgarmasdi — «sahifaga o'tish / 10/стр ishlamayapti».
  const pagerName = props.pageName || props.titleName || props.name
  const NoColumn: IColumnType = NO_COLUMN
  const { t } = useTranslation()
  const { lg, sm, md, xl } = useBreakpoint()   // xl (>=1200) = desktop; 768-1199 = planshet (antd'da 1024 ham «lg»)
  const isMobile = md === false   // Boshliq (2026-09-05): < 768px — kartalar (birinchi render'da undefined = desktop)
  const location = useLocation()
  const query = useQueryParams()
  const bugunBosh = useTodayEmpty()   // Tog'a #438: sukut davri «Сегодня» — bo'sh holat
  useEffect(() => {
    const now = Date.now()
    if (now - lastPermsRefreshAt > 30000) {
      lastPermsRefreshAt = now
      try { window.dispatchEvent(new Event("crm-refresh-perms")) } catch {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.titleName, props.name])

  const queries = qs.parse(location.search, { ignoreQueryPrefix: true })
  const pathName = location.pathname.slice(1)

  const selectableColumns = true
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  // telefon kartalarida tanlash: antd jadvali bilan bir xil kalit (rowKey funksiya/maydon; odatiy "key", bo'lmasa id)
  const pickKey = (r: any) => (typeof props.rowKey === "function" ? (props.rowKey as any)(r) : r?.[(props.rowKey as string) || "key"] ?? r?.id)
  const [dataForExport, setDataForExport] = useState<IColumnType[]>([])
  const [columns, setColumns] = useState([NoColumn, ...props.columns])
  const [exportModal, setExportModal] = useState<boolean>(false)
  const [importModal, setImportModal] = useState<boolean>(false)
  const { authState, authDispatch } = useContext(AuthContext)

  // Rol uchun serverda saqlangan ustun cheklovlarini qo'llaymiz:
  // foydalanuvchi permissionlarida (checkSession orqali yangilanadi) har bir modul
  // uchun `columns` ro'yxati keladi; null/undefined = cheklov yo'q.
  const roleFilteredColumns = useMemo(() => {
    let base = [NoColumn, ...props.columns]
    try {
      const u = authState?.user as any
      // tog'a #4100/#4104: partiya faqat glavniy tizimda — hamkor tizimida (tenant > 1) `mainOnly` ustunlar va mavjud partiya
      // ustunlari (batchNumber / batches / saleBatchNumber yoki «Партия» sarlavhali) jadvaldan, kartalardan va eksportdan olinadi
      if (!isMainUser(u)) base = base.filter((col: any) => !col?.mainOnly && !isBatchColumn(col))
      // audit R4-12 (2026-09-03): KABINET-login (kontragent/magazin/zavod) uchun server tan narx,
      // zakupka narxi va qoldiqni niqoblaydi — ustun qolsa jadvalda «$0» bo'lib ko'rinardi va
      // xato ma'lumotdek o'qilardi. Shu ustunlar kabinetga umuman chiqmaydi.
      // Tizim ADMINI (o'z tenanti bor) kabinet emas — unga hech narsa o'zgarmaydi.
      const isCabinetUser =
        !(Number(u?.tenantId || 0) > 1 && (String(u?.userType || "").toLowerCase() === "admin" || (u as any)?.tenantType === "shop_owner")) &&   // audit F1
        (Number(u?.counterpartyId || 0) > 0 ||
          Number(u?.shopId || 0) > 0 ||
          Number(u?.factoryId || 0) > 0)
      // Boshliq «Ruxsat» (2026-09-13, tog'a #1870): s59 dagi KODLI «tenant > 1 → shtrix-kod yashirin» qoidasi olib tashlandi —
      // endi kontragent/magazin rollari uchun ham ustunlar «Роли и права → ustunlar» (mainRoleColumns, global rol #2/#4) bilan
      // bosh admin tomonidan belgilanadi (default sozlamada shtrix-kod yashirin — perf/seed_partner_columns.js).
      if (isCabinetUser) {
        const hidden = ["costpriceusd", "purchaseusd", "productcount", "factorydebt"]
        base = base.filter(
          (col: any) => !hidden.includes((col.dataIndex?.toString() || "").toLowerCase())
        )
      }
      const perms: any[] = u?.permissions || []
      // `Page`/`GroupedPage` konteynerlari TableExtended'ga `name` sifatida
      // BIRLIK shaklni (masalan "sale") uzatadi, moduleCode esa har doim
      // KO'PLIK ("sales") — shuning uchun eng ishonchli manba `titleName`
      // (Page bu yerga asl `props.name`ni to'liq uzatadi). Aks holda ustun
      // cheklovi hech qachon topilmay, barcha ustunlar ko'rinib qolardi.
      // tog'a #1885 (2026-09-13): guruhlangan ro'yxat ("<modul>ByFilter") va birlik nomlar ham modulga keltiriladi —
      // hamma jadvalning hamma ustuni bitta rol sozlamasiga bo'ysunadi
      const _aliases: Record<string, string> = { sale: "sales", purchase: "purchases", returnSale: "returnSales", returnPurchase: "returnPurchases", transferDay: "transfers", money: "moneys" }
      const _rawFull = (props.titleName || props.name || pathName || "").toString()
      const _raw = _rawFull.endsWith("ByFilter") ? _rawFull.slice(0, -"ByFilter".length) : _rawFull
      const sectionKey = _aliases[_raw] || _raw
      const perm = perms.find(
        (p: any) =>
          p?.moduleCode &&
          String(p.moduleCode).toLowerCase() === sectionKey.toLowerCase()
      )
      if (!perm) return base
      const def = MODULE_COLUMNS_DEFINITION[sectionKey] || []
      if (def.length === 0) return base
      // yashirilgan ustunlar: "col:<key>" (yangi) yoki eski whitelist — moduleColumns.hiddenColumnKeys
      const hiddenKeys = hiddenColumnKeys(perm, def)
      if (hiddenKeys.size === 0) return base
      return base.filter((col: any) => {
        const colId = col.dataIndex?.toString() || ""
        const colTitle = typeof col.title === "string" ? col.title : ""
        // Ustunni avval sarlavha (label), keyin dataIndex (key) bo'yicha aniqlaymiz —
        // bir nechta ustun bitta dataIndex'ga ega bo'lishi mumkin (masalan mainProduct)
        const defEntry =
          (colTitle && def.find((d) => d.label === colTitle)) ||
          def.find((d) => d.key === colId)
        if (!defEntry) return true
        return !hiddenKeys.has(defEntry.key)
      })
    } catch {
      return base
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.columns, props.name, props.titleName, pathName, authState.user])

  const showColumns = roleFilteredColumns
  // Responsiv audit (2026-09-07): ustun tanlovi QURILMA bo'yicha eslab qolinadi (planshet/desktop alohida kalit);
  // planshetda saqlangan tanlov bo'lmasa dastlab 7 ustun — keng jadval 2× gorizontal siljimaydi, qolganini tanlagichdan qo'shish mumkin
  // s83 (2026-09-09): planshet kaliti «t» → «t2». 07.09 dagi standart (birinchi 8 ustun) qoldiq/summa ustunlarini
  // tashlab ketardi va u brauzerda saqlanib qolgan bo'lishi mumkin — bir marta yangi (aqlli) standartga qaytariladi.
  // tog'a #3014 (2026-09-29): «t2» → «t3» — planshetdagi eski saqlangan tanlovda Штрих-код/Артикул yo'q edi; bir marta yangi standart
  // tog'a #3493 (2026-10-06): tanlov SERVERDA (foydalanuvchi profili) — chiqib-kirganda, sessiya tugaganda va boshqa qurilmada ham
  // saqlanadi; kompyuter (d) va planshet/telefon (t) uchun ALOHIDA (tog'a tavsiyani tasdiqladi). Avvalgi brauzer kaliti (oldColsKey)
  // faqat foydalanuvchining eski tanlovini bir marta serverga ko'chirish uchun o'qiladi.
  const colsKey = "cols:" + safePrefKey((props.columnsKey || props.titleName || props.name || pathName || "").toString()) + ":" + (xl ? "d" : "t")
  const oldColsKey = "tx-cols:" + (props.titleName || props.name || pathName || "").toString() + ":" + (xl ? "d" : "t3")
  const [prefsVer, setPrefsVer] = useState(0)
  useEffect(() => {
    const off = onUiPrefs(() => setPrefsVer((v) => v + 1))
    loadUiPrefs()
    return off
  }, [])
  // s269 (2026-09-20, tog'a #2216): ustun tanlovi SARLAVHA MATNI bo'yicha eslab qolinardi. Sarlavha
  // o'zgarsa (tarjima tahriri, ustun nomini aniqlashtirish, til almashtirish) saqlangan ro'yxat mos
  // kelmay qolardi va ustun JIM yo'qolardi — «Остатки да витрина ustuni yo'qolib qolibdi» aynan shu.
  // Jonli tajribada tasdiqlandi: bir xil tanlovda nom «Количество витрины» bo'lsa ustun bor, «Витрина»
  // bo'lsa — yo'q. Endi kalit sifatida BARQAROR `key`/`dataIndex` ishlatiladi; bir xil `dataIndex` li
  // ustunlar (masalan Товар / Штрих-код / Артикул — uchalasi ham `mainProduct`) sarlavha bilan ajratiladi.
  const rawColId = (c: any) => String((c as any)?.key ?? c?.dataIndex ?? "")
  const idTakror = React.useMemo(() => {
    const m = new Map<string, number>()
    ;(roleFilteredColumns || []).forEach((c: any) => { const r = rawColId(c); if (r) m.set(r, (m.get(r) || 0) + 1) })
    return m
  }, [roleFilteredColumns])
  const colTitle = (c: any) => String(c?.title?.toString?.() ?? "")
  const colId = (c: any) => {
    const r = rawColId(c)
    if (!r) return colTitle(c) || String(c?.dataIndex ?? c?.key ?? "")
    return (idTakror.get(r) || 0) > 1 ? r + "|" + colTitle(c) : r
  }
  /** eski (2026-09-20 gacha saqlangan) format — faqat sarlavha matni */
  const eskiColId = (c: any) => String(c?.title?.toString?.() ?? c?.dataIndex ?? c?.key ?? "")
  const parseSaved = (raw: string | undefined | null): string[] | null => {
    if (!raw) return null
    try { const j = JSON.parse(raw); if (Array.isArray(j?.cols)) return j.cols.map(String) } catch {}
    return null
  }
  /** FAQAT foydalanuvchi tanlovi bilan chaqiriladi. Hozir mavjud bo'lmagan (vaqtincha yo'q) avvalgi tanlovlar ham saqlanib qoladi. */
  const saveUserCols = (picked: any[]) => {
    const ids = picked.map(colId)
    const mavjud = new Set(roleFilteredColumns.map(colId))
    const yopiq = (parseSaved(getUiPref(colsKey)) || []).filter((id) => !mavjud.has(id) && !ids.includes(id))
    setUiPref(colsKey, JSON.stringify({ v: 2, cols: [...ids, ...yopiq] }))
    try { localStorage.removeItem(oldColsKey) } catch {}
  }

  /** Saqlangan tanlov bo'lmaganda: kompyuterda hamma ustun, planshetda muhim ustunlar (s83/#3014 qoidasi). */
  const defaultColumns = (): any[] => {
    if (!xl && roleFilteredColumns.length > 8) {
      // s83 (tog'a 2026-09-09): avval TARTIB bo'yicha birinchi 8 ustun olinardi — Остатки da «Общее количество»
      // 11-o'rinda bo'lgani uchun planshetda qoldiq raqami umuman ko'rinmasdi. Endi `tabletKeep` (muhim) va
      // `alwaysVisible` ustunlar albatta qoladi, qolgan joylar tartib bo'yicha to'ldiriladi (tartib buzilmaydi).
      const CHEK = 9
      // s250b: o'lchov ustunlari so'z chegarasi bilan (count, amount, totalPriceUSD, productCount, paidUSD — ha; mainCounterparty — yo'q)
      const OLCHOV = /^(count|amount|qty|quantity|total|summa|sum|status|debt|balance|paid|price)([A-Z_]|$)|[a-z0-9](Count|Amount|Qty|Quantity|Total|Summa|Sum|Status|Debt|Balance|Paid|Price)([A-Z_]|$)/
      const muhim = new Set<number>()
      roleFilteredColumns.forEach((c: any, i: number) => { if (c?.tabletKeep || c?.alwaysVisible) muhim.add(i) })
      // tog'a #3091: `tabletHide` ustunlar (har qatorda bir xil nom/pochta/telefon) «birinchi 4» ga ham, to'ldirishga ham kirmaydi
      const yashir = (i: number) => !!(roleFilteredColumns[i] as any)?.tabletHide
      for (let i = 0; i < Math.min(4, roleFilteredColumns.length); i++) if (!yashir(i)) muhim.add(i)
      // tog'a #3014: tovarni TANIB OLISH ustunlari (Товар / Штрих-код / Артикул / Партия) planshetda ham qoladi
      const tanib = new Set([t("product"), t("barCode"), t("article"), t("batchLbl", "Партия")].map(String))
      // tog'a #4100: partiya ustuni sarlavhasi boshqacha bo'lsa ham (Товары → «Номер партии») dataIndex bo'yicha qoladi
      const partiyaDi = (c: any) => { const di = c?.dataIndex; const s = String(Array.isArray(di) ? di[di.length - 1] : di ?? ""); return s === "batchNumber" || s === "batches" }
      roleFilteredColumns.forEach((c: any, i: number) => { if (tanib.has(colTitle(c)) || partiyaDi(c)) muhim.add(i) })
      roleFilteredColumns.forEach((c: any, i: number) => {
        if (muhim.size < CHEK && !yashir(i) && OLCHOV.test(String(c?.dataIndex ?? ""))) muhim.add(i)
      })
      for (let i = 0; i < roleFilteredColumns.length && muhim.size < CHEK; i++) if (!yashir(i)) muhim.add(i)
      return roleFilteredColumns.filter((c: any, i: number) => muhim.has(i))
    }
    return roleFilteredColumns
  }

  useEffect(() => {
    try {
      // tog'a #3493: tizim tanlovni o'zi QAYTA YOZMAYDI. Avval saqlangan ustun vaqtincha ko'rinmasa (huquqlar qayta yuklanayotganda)
      // «eski format» deb shu holat darhol saqlanib, ustun butunlay yo'qolardi.
      let saved = parseSaved(getUiPref(colsKey))
      let eski = false
      if (!saved) {
        // foydalanuvchining avvalgi BRAUZER tanlovi: ko'rinish o'zgarmaydi, server yuklangach unga bir marta ko'chiriladi
        try {
          const o = JSON.parse(localStorage.getItem(oldColsKey) || "null")
          if (Array.isArray(o) && o.length) { saved = o.map(String); eski = true }
        } catch {}
      }
      if (saved && saved.length) {
        const s = saved
        // s54: amal-ustunlar (alwaysVisible) saqlangan tanlovda bo'lmasa ham ko'rinadi; s269: eski (sarlavhali) format ham taniladi
        const picked = roleFilteredColumns.filter((c: any) =>
          c === NoColumn ? (eski || s.includes(colId(c))) : (s.includes(colId(c)) || s.includes(eskiColId(c)) || c?.alwaysVisible))
        if (picked.length > 1) {
          setColumns(picked)
          if (eski && uiPrefsLoaded()) {
            setUiPref(colsKey, JSON.stringify({ v: 2, cols: picked.map(colId) }))
            try { localStorage.removeItem(oldColsKey) } catch {}
          }
          return
        }
      }
    } catch {}
    setColumns(defaultColumns())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleFilteredColumns, colsKey, prefsVer])

  // Rol uchun yashirilgan modul funksiyalari (export/import/summary/filter/invoice ...).
  // GroupedPage jadvallari birlik nomda keladi — modul nomiga moslaymiz.
  const hiddenFeatures = useMemo(() => {
    try {
      const aliases: Record<string, string> = {
        sale: "sales",
        purchase: "purchases",
        returnSale: "returnSales",
        returnPurchase: "returnPurchases",
        transferDay: "transfers",
      }
      const u = authState?.user as any
      const perms: any[] = u?.permissions || []
      // GroupedPage jadvallar nomi "<modul>ByFilter" ko'rinishida keladi — suffiksni olib tashlaymiz,
      // aks holda funksiya cheklovlari guruhlangan (kunlik) ko'rinishlarda umuman qo'llanmasdi
      const rawKeyFull = (props.titleName || props.name || pathName || "").toString()
      const rawKey = rawKeyFull.endsWith("ByFilter") ? rawKeyFull.slice(0, -"ByFilter".length) : rawKeyFull
      const sectionKey = aliases[rawKey] || rawKey
      const perm = perms.find(
        (p: any) =>
          p?.moduleCode &&
          String(p.moduleCode).toLowerCase() === sectionKey.toLowerCase()
      )
      return Array.isArray(perm?.hiddenFeatures)
        ? (perm.hiddenFeatures as string[])
        : []
    } catch {
      return []
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.name, props.titleName, pathName, authState.user])

  const effHideExport = props.hideExport || hiddenFeatures.includes("export")
  const effHideImport = props.hideImport || hiddenFeatures.includes("import")
  const effHideSummary = props.hideSummary || hiddenFeatures.includes("summary")
  const visibleLeftButtons = useMemo(
    () =>
      (props.leftButtons || []).filter(
        (btn: any) => !hiddenFeatures.includes(String(btn?.key ?? ""))
      ),
    [props.leftButtons, hiddenFeatures]
  )
  // s42: sahifa filtrlari (Поиск, tanlovlar, sanalar…) sarlavhada emas — Фильтр oynasida; umumiy holatga yoziladi
  const setQuick = useSetQuickFilters()
  const quickList = useMemo(() => quickFiltersOf(visibleLeftButtons), [visibleLeftButtons])
  useEffect(() => {
    const key = props.filterMatcher || "filtering"   // tog'a #1931: har jadval o'z matcher'i ostida (drawer ichidagi jadval tashqi jadvalni o'chirmaydi)
    setQuick(quickList, key)
    return () => setQuick([], key)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickList, props.filterMatcher])

  const {
    mutate: collectionBulkDelete,
    isLoading: cLoading,
    error: cError,
  } = useMutation(props.deleteBulkMutation, {
    onSuccess: (response: any) => {
      response?.forEach((item, index) => {
        if (item) {
          message.success(`${t("deleted")}`)
        } else {
          message.error(`${t("notDeleted")}`)
        }
      })
      props.refetch()
    },
    onError: (error: any) => {
      message.error(error.toString())
    },
  })
  const { data, refetch } = useQuery(
    [
      "GET_USER",
      authState.user?.id,
    ],
    () =>
      GET_USER(
        String(authState.user?.id)
      ),
    {
      enabled: false,
      onError: () => {},   // audit F4 (2026-09-04): config.ts yagona toast nuqtasi
    }
  )

  useEffect(() => {
    if (authState.user?.id) {
      refetch()
    }
    // eslint-disable-next-line
  }, [authState.user?.id])

  const rowSelectionConfig = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: T[]) => {
      setSelectedRows(selectedRows)
      props.onRowSelect && props.onRowSelect(selectedRows)
    },
    ...props.rowSelectionConfig,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
  }

  if (selectedRows && props.setIsSelectedRows) {
    props.setIsSelectedRows(selectedRows)
  }

  async function handleImport(file: File) {
    if (!props.sampleData) return

    try {
      const { readImportRows } = await import("../../utils/exportToExcel")   // PERF-07
      const { aliasKeys } = await import("../../utils/importAliases")
      // tog'a #3989: kutilgan ustunlar — birinchi varaq bo'sh bo'lsa, ma'lumotli varaqni tanlash uchun
      const kutilgan = [...Object.keys(props.sampleData || {}), ...Object.values(props.importAliases || {}).flat()]
      const { rows: xom, info } = await readImportRows(file, kutilgan)
      const result = aliasKeys(xom, props.importAliases)   // tog'a #2892
      if (!result || result.length === 0) {
        // tog'a #3989: «Файл пустой» o'rniga — aniq sabab (0 bayt / himoyalangan / Excel emas / varaqlarda qator yo'q) va fayl ma'lumoti
        const sabab = !info.bytes ? t("importZero", "Файл не прочитан — 0 байт. Закройте файл в Excel, сохраните его на компьютер (не только в облаке) и выберите снова.")
          : info.kind === "cfb" ? t("importProtected", "Файл защищён паролем или зашифрован. В Excel снимите защиту и сохраните как «Книга Excel (*.xlsx)».")
          : info.kind === "unknown" ? t("importNotExcel", "Это не файл Excel. Откройте его в Excel и сохраните как «Книга Excel (*.xlsx)».")
          : t("importEmpty")
        const varaqlar = info.sheets.map((x) => `${x.name} — ${x.rows}`).join(", ") || "—"
        notification.error({
          message: sabab, duration: 15,
          description: t("importFileInfo", "Файл: {{f}} ({{kb}} КБ). Листы (строк): {{s}}.", { f: info.name, kb: Math.round((info.bytes / 1024) * 10) / 10, s: varaqlar })
            + (info.bytes && info.kind !== "cfb" && info.kind !== "unknown" ? " " + t("importEmptyHint", "Первая строка листа — заголовки, ниже — данные.") : ""),
        })
        return
      }
      if (info.used && info.sheets[0] && info.used !== info.sheets[0].name)
        message.info(t("importOtherSheet", "Данные взяты с листа «{{s}}» — первый лист пустой", { s: info.used }), 6)
      // tog'a #3927: ro'yxat hali yuklanmagan bo'lsa (sekin internet) import JIM to'xtardi — oyna ochiq, xabar yo'q. Import ro'yxatga bog'liq emas.
      if (props.withoutImportCheck) {
        props.onImport && props.onImport(result)
        setImportModal(false)
        return
      }
      const checkResult = checkObj(Object.keys(props.sampleData), result[0])
      if (!checkResult.hasAll) {
        notification.error({
          message: t("missingFields"),
          description: checkResult.missedProperties
            .map((x) => `${t(x)} - ${x}`)
            .join(" | "),
        })
        return
      }
      props.onImport && props.onImport(result)
      setImportModal(false)
    } catch (err: any) {
      // tog'a #3989: fayl o'qilmadi (boshqa dasturda band / bulutda) — tushunarli xabar
      if (err?.importRead) message.error(t("importReadFail", "Браузер не смог прочитать файл. Закройте его в Excel и выберите снова (или сохраните копию под новым именем)."), 10)
      else message.error(err.toString())
    }
  }

  useEffect(() => {
    // tog'a (2026-09-02, 835): ustun ruscha «Сумма y.e» sarlavhasi bo'yicha qidirilardi — o'zbek/ingliz tilida
    // hech qachon topilmay, har renderda setDataForExport → cheksiz halqa (100% CPU, React #185 «Kutilmagan xatolik»).
    // Endi tildan mustaqil: dataIndex bo'yicha.
    const logic = dataForExport.find(({ dataIndex }) => dataIndex === "amountUSD")
    if (props.name === "money" && !logic) {
      setDataForExport([
        ...columns,
        {
          title: t("amountUSD"),
          dataIndex: "amountUSD",
          align: "center",
        },
      ])
    }
  }, [props.name, dataForExport, columns])

  async function handleExport(values: IExcelOptions) {   // PERF-07: eksport modullari ichkarida yuklanadi
    // tog'a #309: «hamma yozuvlar» endi sahifa ochilganda oldindan yuklanmaydi — eksportda kutib olinadi
    const yangi: any = props.refetchAllData ? await Promise.resolve(props.refetchAllData()).catch(() => null) : null
    const hammasi: any[] = yangi?.data?.data || props.allData || []
    try {
      let detail: any = { name: t(pathName) }
      if (queries.begin) {
        detail.dateInterval = [queries.begin, queries.end]
      } else {
        detail.dateInterval = [moment(new Date())]
      }
      if (authState.user) {
        detail.user = authState.user
      }

      let exportData = selectedRows.length !== 0 ? selectedRows : hammasi
      if (values.extension === ExcelExtensions.PDF) {
        let temp1 = {}
        const { exportPDF } = await import("../../utils/exportToPDF")   // PERF-07
        exportPDF(
          exportData.map((x, index) => [
            columns
              .filter((x) => x.renderString)
              .forEach((col, i) => {
                const renderFunction = col?.renderString
                  ? col.renderString
                  : col?.render
                  ? col?.render
                  : (v: string | number) => v
                temp1[col.title?.toString() || ""] = renderFunction(
                  x[col.dataIndex?.toString() || ""],
                  x,
                  i
                )
              }),
            ...Object.values(temp1),
          ]),
          `${t(pathName)}`,
          values.filename,
          [["", ...Object.keys(temp1)]]
        )
      } else {
        const exportCols = (props.name === "money" ? dataForExport : columns).filter(
          (x) => x.dataIndex
        )
        const exportRows = exportData.map((row, i) => {
          let temp: any = {}
          exportCols.forEach((col, i) => {
            const renderFunction = col?.renderString
              ? col.renderString
              : col?.render
              ? col?.render
              : (v: string) => v
            temp[col.title?.toString() || ""] = renderFunction(
              row[col.dataIndex?.toString() || ""],
              row,
              i
            )
          })
          return temp
        })

        if (
          exportRows.length > 0 &&
          props.summaryKeys &&
          props.summaryKeys.length > 0
        ) {
          const totalOutcomeObj =
            props.totalOutcome || props.pageInfo?.totalOutcome || {}
          let summaryRow: any = {}
          exportCols.forEach((col, idx) => {
            const title = col.title?.toString() || ""
            const key = col.dataIndex?.toString() || ""
            if (idx === 0) {
              summaryRow[title] = t("posTotal")
            } else if (
              props.summaryKeys?.some(
                (sk) => sk.toLowerCase() === key.toLowerCase()
              )
            ) {
              const matchedKey = Object.keys(totalOutcomeObj).find(
                (k) => k.toLowerCase() === key.toLowerCase()
              )
              let totalVal =
                matchedKey &&
                totalOutcomeObj[matchedKey] !== undefined &&
                totalOutcomeObj[matchedKey] !== null
                  ? totalOutcomeObj[matchedKey]
                  : undefined

              if (totalVal === undefined || totalVal === null) {
                totalVal = exportData.reduce((acc: number, curr: any) => {
                  const renderFn = props.summaryKeyRenders?.[key]
                  const val = renderFn ? renderFn(curr) : Number(curr[key]) || 0
                  return acc + (Number(val) || 0)
                }, 0)
              }
              summaryRow[title] = exportTotal(key, totalVal)   // tog'a #1952: minus faqat qarzlarda
            } else {
              summaryRow[title] = ""
            }
          })
          exportRows.push(summaryRow)
        }

        const { exportJSON2Excel } = await import("../../utils/exportToExcel")   // PERF-07
        exportJSON2Excel(
          exportRows,
          values.worksheetName,
          `${values.filename}.${values.extension}`,
          detail
        )
      }
      // exportTabletoExcel(document.getElementById(`table-${props.name}`), values.worksheetName, `${values.filename}.${values.extension}`);
      setExportModal(false)
    } catch (error: any) {
      message.error(error.toString())
    }
  }

  async function handleDelete(rows: any) {
    if (!rows.length) return
    collectionBulkDelete(rows?.map((x) => +x))
  }

  function handleActionButtonClick(type: TableActions) {
    if (type === TableActions.IMPORT) {
      setImportModal(true)
      return
    }

    if (type === TableActions.EXPORT) {
      setExportModal(true)
      return
    }

    if (type === TableActions.ADD) {
      props.onAdd && props.onAdd()
      return
    }

    // if (!selectedRows.length) {
    //   message.warn(t("selectAtLeastOneRow"));
    //   return;
    // }

    switch (type) {
      case TableActions.DELETE:
        props.onDelete
          ? props.onDelete(selectedRows.map((x) => x.key))
          : handleDelete(selectedRows.map((x) => x.key))
        break
      default:
        break
    }
  }

  function handleTableChange(
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<T> | SorterResult<T>[]
  ): void {
    props.onSort &&
      !Array.isArray(sorter) &&
      props.onSort({
        field: sorter.field?.toString() || "",
        order:
          sorter.order === "ascend"
            ? "ASC"
            : sorter.order === "descend"
            ? "DESC"
            : "",
      })
  }

  const filterMoneyByType = useMemo(
    () => props?.dataSource?.filter((x: any) => x?.type === props.type),
    [props?.dataSource, props?.type]
  )
  // tog'a #4153 (+++ #4181): ustun sarlavhasi ilova sarlavhasi ostida, «Итого» ekran pastida qotib turadi.
  // Telefon kartalarida va bo'sh / yuklanayotgan jadvalda — yo'q (eskidek ko'rinadi)
  const jadvalQatorlari = props.name === "money" ? filterMoneyByType : props.dataSource
  const stick = useStickyTable(!isMobile && (jadvalQatorlari?.length ?? 0) > 0)
  return (
    <>
      {/* s42: standart Фильтр oynasi — sahifa o'z filterComponent'ini bermasa (Остатки kabi to'g'ridan TableExtended) */}
      {!props.filterComponent && !props.hasFilter && quickList.length > 0 && (
        <QuickModal matcher={props.filterMatcher || "filtering"} title={t("filter")} footer={null} width={640}>
          <div />
        </QuickModal>
      )}
      <Header
        filterComponent={props.filterComponent}
        handleActionButtonClick={handleActionButtonClick}
        TableActions={TableActions}
        tableProps={props.tableProps}
        hideDelete={props.hideDelete}
        hideExport={effHideExport}
        rightButtons={props.rightButtons}
        hideAdd={props.hideAdd}
        setExportModal={setExportModal}
        handleExport={handleExport}
        exportModal={exportModal}
        hideImport={effHideImport}
        importModal={importModal}
        sampleData={props.sampleData}
        importColumnsHint={props.importColumnsHint}
        importTemplate={props.importTemplate}
        setImportModal={setImportModal}
        cLoading={cLoading}
        handleImport={handleImport}
        cError={cError}
        leftButtons={visibleLeftButtons}
        filterMatcher={props.filterMatcher}
        hasFilter={props.hasFilter}
        isHasTitle={props.isHasTitle}
        titleName={props.titleName}
        loadingAllData={props.loadingAllData}
        selectedRows={selectedRows}
      />
      <Layout className="table-with-actions img_header_r">
        {props.topContent}
        {isMobile ? (
          <>
          <MobileCards
            columns={columns as any[]}
            dataSource={(props.name === "money" ? filterMoneyByType : props.dataSource) as any[]}
            rowKey={props.rowKey as any}
            loading={!!(props.loading || cLoading)}
            emptyText={bugunBosh?.description}   // Tog'a #438: «За сегодня записей нет»
            pageSize={0}
            // tog'a #3410 (2026-10-04): telefonda yozuv kartasini ochib bo'lmasdi — kompyuterda qator 2 marta bosilganda
            // ochiladi (onRow.onDoubleClick), kartochkalarga esa bu ulanmagan edi. Endi kartochkaga bir bosish = o'sha amal
            // (tahrir huquqi bo'lmasa onRow yo'q — ochilmaydi; tugma/havolaga tegish onDoubleClick ichida chetlanadi).
            onRowClick={props.onRow ? (r: any, e?: any) => { try { (props.onRow as any)(r, undefined)?.onDoubleClick?.(e || { target: null }) } catch {} } : undefined}
            // tanlash oynasida (rowSelectionType berilgan) kartaga bosish = tanlash; tanlov jadvaldagi bilan bir xil holatda (selectedRows) turadi
            selection={props.rowSelectionType ? {
              type: props.rowSelectionType === "radio" ? "radio" : "checkbox",
              isSelected: (r: any) => selectedRows.some((x: any) => pickKey(x) === pickKey(r)),
              onToggle: (r: any) => {
                const k = pickKey(r)
                const next = props.rowSelectionType === "radio" ? [r] : selectedRows.some((x: any) => pickKey(x) === k) ? selectedRows.filter((x: any) => pickKey(x) !== k) : [...selectedRows, r]
                setSelectedRows(next)
                props.onRowSelect && props.onRowSelect(next as any)
              },
            } : undefined}
            rowClassName={(record: any) =>
              monthDiff(new Date()) > new Date(record?.datePurchase) ? "danger" : record.isDefective && !props.isDefective ? "warning" : ""
            }
          />
          {/* tog'a 1401 (2026-09-06): telefonda ham server sahifalagichi — kartalar faqat joriy sahifani ko'rsatadi, keyingi sahifaga o'tish shu yerdan */}
          {props.pageInfo && (
            <div className="PagenationWrapper mobile-server-pager">
              <div className="TableFooetr1">
                <Pagination name={pagerName} {...props.pageInfo} pageInfo={props?.pageInfo} />
              </div>
            </div>
          )}
          </>
        ) : (
        <Table
          {...props}
          ref={stick.ref}
          sticky={stick.sticky}
          tableLayout={props.tableLayout ?? (stick.sticky ? asliLayout(columns as any[], "max-content") : undefined)}
          id={`table-${props.name}`}
          bordered
          size={lg ? props.size : "small"}
          pagination={false}
          loading={props.loading || cLoading}
          // Tog'a #438: davr bugun bo'lsa — «За сегодня записей нет» + «Показать за неделю / месяц» (sahifa o'z matnini bersa — o'shasi)
          locale={bugunBosh && !(props.locale as any)?.emptyText ? { ...(props.locale || {}), emptyText: bugunBosh.element } : props.locale}
          // Msg 191: ustunlar siqilib qolmasin — jadval tabiiy kenglikda,
          // torlikda ichki gorizontal scroll (butun tizim jadvallari uchun)
          scroll={{ x: "max-content" }}
          rowSelection={{
            type: props.rowSelectionType || "checkbox",
            ...rowSelectionConfig,
            preserveSelectedRowKeys: true,
          }}
          style={{ marginBottom: "20px" }}
          columns={columns}
          dataSource={
            props.name === "money" ? filterMoneyByType : props.dataSource
          }
          rowClassName={(record: any) =>
            monthDiff(new Date()) > new Date(record?.datePurchase)
              ? "danger"
              : record.isDefective && !props.isDefective
              ? "warning"
              : record?.counterpartyDEBT !== undefined && record?.counterpartyDEBT !== null && Number(record?.counterpartyDEBT) <= 0
              ? "" // Boshliq (2026-09-04): 8-qaror — musbat = qarzdor; qarzi yo'q/avansli kontragent QIZIL emas (avval teskari edi)
              : record.dateOrder
              ? ""
              : record?.paymentDate &&
                moment(record?.paymentDate).add(5, "hours") < moment()
              ? "danger"
              : ""
          }
          onChange={handleTableChange}
          summary={(pageData: readonly any[]) => {
            if (!props.summaryKeys?.length || !pageData.length) return

            const sortedSummaryKeys: string[] = []

            columns.forEach((x) => {
              const key = x.dataIndex?.toString() || ""
              if (props.summaryKeys?.includes(key)) {
                sortedSummaryKeys.push(key)
              }
            })

            // {
            //   !props.hideExport && (
            //     <>
            //       <Button
            //         size="large"
            //         className="table-action-btn"
            //         icon={<Download />}
            //         onClick={() => handleActionButtonClick(TableActions.EXPORT)}
            //       >
            //         {lg && t("export")}
            //       </Button>
            //       <ExportOptionsModal
            //         loading={
            //           selectedRows.length === 0 ? props.loadingAllData : false
            //         }
            //         onCancel={() => setExportModal(false)}
            //         visible={exportModal}
            //         onOk={handleExport}
            //       />
            //     </>
            //   );
            // }

            // {!props.hideAdd && (
            //   <Button
            //     size="large"
            //     className="table-action-btn"
            //     icon={<Plus />}
            //     onClick={() => handleActionButtonClick(TableActions.ADD)}
            //   >
            //     {lg && t("add")}
            //   </Button>
            // )}
            if (effHideSummary) return

            // tog'a #4153: «Итого» qatori ekran pastida qotadi (antd: summary aynan <Table.Summary fixed> bo'lsa)
            return (
              <Table.Summary fixed={stick.sticky ? "bottom" : undefined}>
                <TableSummary
                  isGroup={props.isGroup}
                  queryVariables={props.totalOutcomeQueryVariables}
                  summaryKeys={sortedSummaryKeys}
                  summaryKeyRenders={props.summaryKeyRenders}
                  summaryCellRenders={props.summaryCellRenders}
                  data={pageData}
                  allData={props.allData}
                  totalOutcome={props.totalOutcome || props.pageInfo?.totalOutcome}
                  columns={columns}
                  name={props.name}
                />
              </Table.Summary>
            )
          }}
          footer={() => (
            <div className="PagenationWrapper">
              <div className="TableFooetr1">
                {props.pageInfo && (
                  <Pagination
                    name={pagerName}
                    {...props.pageInfo}
                    pageInfo={props?.pageInfo}
                  />
                )}
              </div>
              <div className="TableFooetr2">
                {selectableColumns && (
                  <Select
                    mode="multiple"
                    size={lg ? "large" : "middle"}
                    value={showColumns.map((x, i) => (columns.includes(x) ? i : -1)).filter((i) => i >= 0)}
                    placeholder={t("selectColumns")}
                    maxTagCount={lg ? 3 : 2}
                    onChange={(values) => {
                      const picked = showColumns.filter((x, i) => values.includes(i))
                      setColumns(picked)
                      saveUserCols(picked)
                    }}
                    data-testid="cols-picker"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <div style={{ borderTop: "1px solid rgba(128,128,128,.25)", padding: 4 }}>
                          <Button type="link" size="small" block data-testid="cols-reset"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {
                              setUiPref(colsKey, null)
                              try { localStorage.removeItem(oldColsKey) } catch {}
                              setColumns(defaultColumns())
                            }}>
                            {t("resetColumns", "Сбросить по умолчанию")}
                          </Button>
                        </div>
                      </>
                    )}
                    options={
                      showColumns?.map((x, i) => ({
                        label: x.title?.toString() || "",
                        value: i,
                      })) || []
                    }
                  />
                )}
              </div>
            </div>
          )}
        />
        )}
      </Layout>
    </>
  )
}
